module.exports = __webpack_public_path__ + "img/다크프리스트.d480634a.png";